module.exports = __webpack_public_path__ + "img/public-event.ef37274a.svg";